import { SCard } from 'components/shared/s-polaris';

/**
 * Placeholder for `MarketRateCountryCard` while its provider sections are still loading — same
 * shape as `RateForProviderSelectorSkeleton` (the zone step's equivalent), minus the trailing
 * "add rate" button row, since a country card has no card-level action of its own.
 */
const MarketRateCountryCardSkeleton: React.FC<MarketRateCountryCardSkeletonProps> = ({ rows = 2 }) => (
    <SCard>
        <div className="skeleton-block h-5 w-2/5 rounded-sm" />
        <div className="flex flex-col gap-2 py-3">
            {Array.from({ length: rows }).map((_, index) => (
                <div key={index}>
                    <div className="flex justify-between items-center gap-10">
                        <div className="flex gap-2 items-center">
                            <div className="skeleton-block size-10 shrink-0 rounded-lg" />
                            <div className="skeleton-block h-4 w-30 rounded-sm" />
                        </div>
                        <div className="w-full max-w-100">
                            <div className="skeleton-block h-8 w-full rounded-lg" />
                        </div>
                    </div>
                    {rows - 1 !== index && (
                        <div className="pt-2">
                            <s-divider />
                        </div>
                    )}
                </div>
            ))}
        </div>
    </SCard>
);

interface MarketRateCountryCardSkeletonProps {
    rows?: number;
}

export default MarketRateCountryCardSkeleton;
